import { render, staticRenderFns } from "./order_history_pdf_viewer.vue?vue&type=template&id=9973a45e&scoped=true&"
import script from "./order_history_pdf_viewer.vue?vue&type=script&lang=js&"
export * from "./order_history_pdf_viewer.vue?vue&type=script&lang=js&"
import style0 from "./order_history_pdf_viewer.vue?vue&type=style&index=0&id=9973a45e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9973a45e",
  null
  
)

export default component.exports